import React from "react";
import "./Ceo.css";
import salmanPhoto from "../../assets/salman.jpg";

export default function CEO() {
  return (
    <div className="ceo-page">
      <section className="ceo-hero">
        <div className="ceo-hero-card">
          <div className="ceo-hero-grid">
            <div className="ceo-photo-wrap">
              <div className="ceo-photo-frame">
                <img
                  src={salmanPhoto}
                  alt="Salman Saeed"
                  className="ceo-photo"
                />
                <div className="ceo-photo-glow" />
              </div>
            </div>

            <div className="ceo-content">
              <div className="ceo-badge">Founder & CEO</div>

              <h1 className="ceo-name">Salman Saeed</h1>

              <p className="ceo-lead">
                A technologist focused on building intelligent systems that are
                structured, scalable, and aligned with real human use. His work
                bridges deep engineering with clear product thinking.
              </p>

              <div className="ceo-tags">
                <span>AI Systems</span>
                <span>Product Architecture</span>
                <span>Frontend + Backend Design</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ceo-section">
        <div className="ceo-section-head">
          <div className="ceo-section-tag">Background</div>
          <h2>Engineering with depth and direction</h2>
          <p>
            Salman Saeed is a software engineer and system architect whose work
            focuses on clarity, structure, and long-term scalability. His
            approach is rooted in understanding how systems behave across layers
            — from user interface to backend infrastructure.
          </p>
        </div>

        <div className="ceo-grid ceo-grid-2">
          <article className="ceo-card">
            <h3>Early foundation</h3>
            <p>
              Beginning his programming journey at a very young age, Salman
              developed a strong intuition for systems, logic, and software
              design. This early exposure shaped his ability to work across both
              low-level and high-level architecture.
            </p>
          </article>

          <article className="ceo-card">
            <h3>Technical direction</h3>
            <p>
              His work spans frontend systems, backend infrastructure, AI
              integration, and developer tooling. He focuses on building systems
              that are not just functional, but structured in a way that scales
              cleanly.
            </p>
          </article>
        </div>
      </section>

      <section className="ceo-section">
        <div className="ceo-feature-card">
          <h2>Philosophy</h2>
          <p>
            The guiding principle behind his work is simple: systems should be
            understandable, predictable, and aligned with real-world usage. This
            belief shapes both product development and engineering decisions
            across Conscious Neurons.
          </p>

          <p>
            Rather than building complexity for its own sake, the focus remains
            on clarity, usability, and meaningful system behavior.
          </p>
        </div>
      </section>

      <section className="ceo-section">
        <div className="ceo-quote-card">
          <p>The question that drives the work:</p>
          <blockquote>
            What if software did not just function — but was structured in a way
            that people could actually understand and trust?
          </blockquote>
        </div>
      </section>
    </div>
  );
}
